import { ArrowRight, ArrowUpRight } from "iconoir-react";
import * as React from "react";

import { cn } from "@/lib/utils";

import { Link } from "./link";
import type { LinkProps } from "./link";

export interface ArrowLinkProps extends LinkProps {
  /**
   * Render the external arrow icon (↗) instead of the default right arrow (→).
   * Useful when pointing at off-site resources.
   */
  externalIcon?: boolean;
}

const ArrowLink = React.forwardRef<HTMLAnchorElement, ArrowLinkProps>(
  ({ children, className, external, externalIcon, href, ...props }, ref) => {
    const Icon = externalIcon ? ArrowUpRight : ArrowRight;
    return (
      <Link
        ref={ref}
        href={href}
        external={external}
        className={cn(
          "group text-grey-900 decoration-grey-300 inline-flex items-center gap-1.5",
          "text-ds-body-md font-medium no-underline hover:underline",
          "decoration-1 underline-offset-[6px]",
          "focus-visible:outline-pulse-700 focus-visible:rounded-ds-xs focus-visible:outline-2 focus-visible:outline-offset-2",
          className
        )}
        {...props}
      >
        {children}
        <Icon
          aria-hidden
          className={cn(
            "size-[0.875em] shrink-0 transition-transform duration-150 ease-out",
            "group-hover:translate-x-[3px] motion-reduce:transition-none motion-reduce:group-hover:translate-x-0"
          )}
        />
      </Link>
    );
  }
);
ArrowLink.displayName = "ArrowLink";

export { ArrowLink };
